import {Expose, Type} from "class-transformer";
import User from "./User";
import Model from "./Model";
import * as moment from "moment";

export default class Special extends Model implements Likable{
    title: string;
    description: string;

    @Type(() => User)
    user: User;

    @Expose({name: "user_id"})
    userId: number;

    @Type(()=>Date)
    @Expose({name: "start_date"})
    startDate: Date;

    @Type(()=>Date)
    @Expose({name: "end_date"})
    endDate: Date;

    //likes
    @Expose({name: "like_count"})
    likeCount: number;

    @Expose({name: "is_liked"})
    isLiked: boolean;

    prettyStartDate(){
        return this.prettyDate(this.startDate, '12:00');
    }

    prettyEndDate(){
        return this.prettyDate(this.endDate, '11:59');
    }

    prettyEndDateString(){
        const prefix = this.endDate >= new Date() ? 'Ends on' : 'Expired'
        return `${prefix} ${this.prettyEndDate()}`
    }

    private prettyDate(date: Date, match: string):string {
        const strDate = moment(date).format('hh:mm');
        if(strDate == match)
            return moment(date).format('MMMM D, YYYY');
        else
            return moment(date).format('MMMM D, YYYY hh:mm A')
    }
}


// WEBPACK FOOTER //
// ./app/client/_data/models/Special.ts